// @flow
import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import styled from 'styled-components/macro';
import {
  mobileHeaderHeight,
  tabletHeaderHeight,
  desktopHeaderHeight
} from './LayoutStyles';

type Props = {};

const PageTitleH6 = styled.h6`
  color: ${props => props.theme.dustyGray};
  font-weight: 300;
  /* position: fixed; */
  /* left: 50vw; */
  /* transform: translate(-50%, -50%); */
  /* top: calc(${mobileHeaderHeight} / 2); */
  @media screen and (min-width: 768px) {
    /* top: calc(${tabletHeaderHeight} / 2); */
    font-size: 1.3rem;
  }
  @media screen and (min-width: 1024px) {
    /* top: calc(${desktopHeaderHeight} / 2); */
    letter-spacing: 0.08rem;
  }
`;

export default class PageTitle extends Component<Props> {
  render() {
    return (
      <PageTitleH6>
        <Route exact path="/" render={() => 'Dashboard'} />
        <Route
          path="/commission-payouts/due"
          render={() => 'Commission Payouts'}
        />
        <Route
          path="/commission-payouts/paid"
          render={() => 'Commission Payouts'}
        />
        <Route
          path="/merchant-transactions"
          render={() => 'Merchant Transactions'}
        />
        <Route path="/partners" render={() => 'Partners'} />
        <Route path="/account" render={() => 'Account'} />
        <Route path="/marketing" render={() => 'Marketing'} />
        <Route path="/merchants" render={() => 'Merchants'} />
        <Route path="/support" render={() => 'Support'} />
        {/* <Route path="/signin" render={() => 'Sign in'} /> */}
      </PageTitleH6>
    );
  }
}
